import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import { throwIfHasNoPermission } from "@/utils/permissions";

import NewsList from "@/modules/news/admin/components/NewsList";
import { fetchEntriesQueryOptions } from "@/modules/news/admin/services";

export const Route = createFileRoute("/admin/_panel/_news/news/")({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "news.news.view");

    return {
      crumb: [
        {
          label: context.t("Manage News", { ns: "news.admin" }),
        },
      ],
    };
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchEntriesQueryOptions()),
});

function Component() {
  const { t } = useTranslation("news.admin");

  return (
    <Container
      title={t("News", {
        ns: "core.shared",
      })}
      description={t("Manage, Create, Edit News", {
        ns: "news.admin",
      })}
    >
      <NewsList />
    </Container>
  );
}
